<script lang="ts">
  import {EventType} from '$lib/machines/auth';

  import {Loader} from '$lib/components/loader';
  import {Icon, IconId} from '$lib/components/icon';

  import {authService} from '$lib/stores/auth';

  function handleLogout() {
    authService.send(EventType.RequestLogout);
  }
</script>

<div class="menu-container menu-container--account">
  <ul class="menu menu--account">
    <li class="menu__item">
      {#if $authService.matches('unknown') || $authService.matches('initial')}
        <button disabled>
          <span class="menu__item__icon">
            <Loader />
          </span>

          <span class="menu__item__text">Loading...</span>
        </button>
      {/if}

      {#if $authService.matches('authd')}
        <button on:click={handleLogout}>
          <span class="menu__item__icon">
            <Icon id={IconId.Logout} />
          </span>

          <span class="menu__item__text">Log out</span>
        </button>
      {/if}

      {#if $authService.matches('loggingOut')}
        <button disabled>
          <span class="menu__item__icon">
            <Loader />
          </span>

          <span class="menu__item__text">Logging out</span>
        </button>
      {/if}
    </li>
  </ul>
</div>
